import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button, Row, Container, Col, Modal, ModalHeader, ModalBody, Label } from 'reactstrap';
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import { showLoader, hideLoader } from '../../redux/ducks/application';
import ReactTooltip from 'react-tooltip';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faInfoCircle, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { CONFIG } from './../../Utils/config';
import {
    getFormattedInt, getFormattedFloat, REGIONS, CURRENCY, getDateFormatString, substringStripHtmlTag, stripHtmlTags,
} from './../../Utils/utils';
import ListingTile from '../../Views/Shared/ListingTile/ListingTile';
import './Home.css';
import Geocode from "react-geocode";
import vendor_no from './../../Assets/Img/ventor-list.png';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import leadstory from './../../Assets/Img/lead-story.png';
import Helmet from '../../Utils/Helmet';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            practicesData: [],
            financeNewsData: [],
            newsAndEventsData: [],
            latestNewsAndEvents: [],
            leadStories: [],
            isAdvancedSearch: false,
            isOpen: false,
            // userInput: '',
            showPropertyNameList: false,
            dropdownOpen: false,
            userInput: '',
            propertyNameList: [],
            propertyTypeList: [],
            propertyTypeId: '',
            cityList: [],
            isAdvanedPopup: false,
            stateList: [],
            selectedStates: [],
            selected: [],
            setSelected: [],
            selectedPropertyType: [],
            selectedMSA: [],
            backupList: [],
            msaList: [],
            selectedValue: null,
            selectedValueMSA: null,
            stateId: '',
            MSAListId: '',
            msaId: '',
            showCityList: false,
            cityName: '',
            searchId: '',
            isRoomExpansion: false,
            isPortfolios: false,
            isExcludeProtfolios: false,
            lat: '',
            lng: '',
            searchData: [],
            cityId: '',
            priceRangeTypesList: [],
            measurementsList: [],
            marketFeatureList: [],
            MVPMarketPSFAverage: '',
            MVPAveragePopulationPerStore: '',
            MVPCurrentSQFTPerCapita: '',
            addressError: '',
            selectedList: null,
            noKeyWord: false,
            propertyTypeIds: '',
            displayValue: 'Property Search',
            imgId: 0,
            minPrice: '',
            priceError: false,
            maxPrice: '',
            minBuild: '',
            maxBuild: '',
            buildError: false,
            minLot: '',
            maxLot: '',
            lotError: false,
            maxNRSF: '',
            minNRSF: '',
            nrsfError: false,
            defaultLotId: 1,
            defaultTypeRangeID: 1,
            proxAddress: '',
            defaultZip: '',
            defaultProximity: 5,
            defaultPSF: '',
            defaultPop: '',
            defaultSqFt: '',
            defaultShow: false,
            defaultExpansion: '',
            proxDisabled: true,
            zipDisabled: true,
            open: false,
            openSearch: false,
            openMSA: false,
            isMSAError: false,
            listingCount: null
        };

        this.typeChange = this.typeChange.bind(this);
        this.handleKeyChange = this.handleKeyChange.bind(this);
        this.onKeyFocus = this.onKeyFocus.bind(this);
        this.multiselectRef = React.createRef();
        this.onStateSelect = this.onStateSelect.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.roomExpansionOnChange = this.roomExpansionOnChange.bind(this);
        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.toggle = this.toggle.bind(this);
        this.signInPopup = this.signInPopup.bind(this);
        this.contactPopup = this.contactPopup.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        Geocode.setApiKey(CONFIG.GeolocationApiKey);
        Geocode.setLanguage("en");
        Geocode.enableDebug();

        if (window.location.pathname.indexOf('/signin') >= 0) {
            this.signInPopup();
        }

        if (window.location.pathname.indexOf('/contact') >= 0) {
            this.contactPopup();
        }

        this.autoCompleteClearEventListener();
        this.getListingCount();
        this.getPropertiesType();
        this.getMeasurementsTypes();
        this.getHomeData();
        this.getMarketfeatures();
        this.getFeaturedListings();
        this.getFeaturedVendorListings();
    }

    signInPopup() {
        document.getElementById("loginclick").click();
    }

    contactPopup() {
        document.getElementById("contactForm").click();
    }

    getListingCount() {
        axios.get(CONFIG.API_URL + 'home/lising/count/' + CONFIG.REGION_ID).then(response => {
            if (response.status === 200) {

                this.setState({ listingCount: response.data });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    getFeaturedListings() {
        let token = localStorage.getItem('accessKey');
        if (token) {
            axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
        }
        axios.get(CONFIG.API_URL + 'home/featured/listings/' + CONFIG.REGION_ID).then(response => {
            if (response.status === 200) {
                var property = response.data;

                this.setState({ featuredListings: property });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    getFeaturedVendorListings() {
        let token = localStorage.getItem('accessKey');
        if (token) {
            axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
        }
        axios.get(CONFIG.API_URL + 'vendor/featured/list/' + CONFIG.REGION_ID).then(response => {
            if (response.status === 200) {
                var property = response.data;

                this.setState({ featuredVendorListings: property });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }


    handleKeyChange(e) {

        const userInput = e.currentTarget.value;

        var obj = { PropertyName: userInput };

        this.setState({ userInput: obj, noKeyWord: false });
        if (userInput.length >= 2) {
            const data = {
                "Keyword": userInput,
                "PropertyTypeIds": this.state.propertyTypeIds,
                "RegionId": CONFIG.REGION_ID

            };
            axios.post(CONFIG.API_URL + 'search', data).then(response => {
                if (response.status === 200) {

                    this.setState({ propertyNameList: response.data, showPropertyNameList: true });
                }
            })
                .catch(err => {
                    this.setState({ isLoading: false });
                });
        }else{
           
            if(userInput.length===0){
                this.setState({ propertyNameList: [], showPropertyNameList: true });
            }
           
        }
    }

    toggle() {
        this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
    }

    onKeyFocus() {
        const { showPropertyNameList } = this.state;
        this.setState({ showPropertyNameList: !showPropertyNameList });
    }

    onCityKeyFocus() {
        const { showPropertyNameList } = this.state;
        this.setState({ showPropertyNameList: !showPropertyNameList });
    }

    onKeyPress(e) {
        const re = /[0-9,.]+/g;
        if (e.key !== "Enter") {
            if (!re.test(e.key)) {
                e.preventDefault();
            }
        }
    }

    onLotTypeChange(e) {
        if (e.target !== null) {
            let defaultLotId = parseInt(e.target.value, 10);
            this.setState({ defaultLotId: defaultLotId })
        }
    }

    onPriceTypeChange(e) {

        if (e.target !== null) {
            let defaultTypeRangeID = parseInt(e.target.value, 10);
            this.setState({ defaultTypeRangeID: defaultTypeRangeID })
        }

    }

    onKeyPriceNumberChange(e) {
        let minPrice = this.state.minPrice;
        let maxPrice = this.state.maxPrice;;
        if (e.target.name === "MinPrice") {
            minPrice = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (maxPrice !== "" && (parseInt(minPrice.replace(/,/g, ''), 10) > parseInt(maxPrice.replace(/,/g, ''), 10))) {
                this.setState({ priceError: true })
            }
            else {
                this.setState({ priceError: false })
            }
        }
        else if (e.target.name === "MaxPrice") {
            maxPrice = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (minPrice !== "" && (parseInt(minPrice.replace(/,/g, ''), 10) > parseInt(maxPrice.replace(/,/g, ''), 10))) {

                this.setState({ priceError: true })
            }
            else {
                this.setState({ priceError: false })
            }

        }

        this.setState({ minPrice: minPrice, maxPrice: maxPrice });
    }


    onKeyLotNumberChange(e) {

        let minLot = this.state.minLot;
        let maxLot = this.state.maxLot;
        if (e.target.name === "MinLotSize") {
            minLot = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (maxLot !== "" && (parseInt(minLot.replace(/,/g, ''), 10) > parseInt(maxLot.replace(/,/g, ''), 10))) {
                this.setState({ lotError: true })
            }
            else {
                this.setState({ lotError: false })
            }
        }
        else if (e.target.name === "MaxLotSize") {
            maxLot = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (minLot !== "" && (parseInt(minLot.replace(/,/g, ''), 10) > parseInt(maxLot.replace(/,/g, ''), 10))) {

                this.setState({ lotError: true })
            }
            else {
                this.setState({ lotError: false })
            }

        }

        this.setState({ minLot: minLot, maxLot: maxLot });
    }


    onKeyNRSFNumberChange(e) {
        let minNRSF = this.state.minNRSF;
        let maxNRSF = this.state.maxNRSF;
        if (e.target.name === "MinNRSF") {
            minNRSF = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (maxNRSF !== "" && (parseInt(minNRSF.replace(/,/g, ''), 10) > parseInt(maxNRSF.replace(/,/g, ''), 10))) {
                this.setState({ nrsfError: true });
            }
            else {
                this.setState({ nrsfError: false });
            }
        }
        else if (e.target.name === "MaxNRSF") {
            maxNRSF = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (minNRSF !== "" && (parseInt(minNRSF.replace(/,/g, ''), 10) > parseInt(maxNRSF.replace(/,/g, ''), 10))) {

                this.setState({ nrsfError: true })
            }
            else {
                this.setState({ nrsfError: false })
            }

        }
        this.setState({ minNRSF: minNRSF, maxNRSF: maxNRSF });
    }

    onKeyBuildNumberChange(e) {

        let minBuild = this.state.minBuild;
        let maxBuild = this.state.maxBuild;;
        if (e.target.name === "MinSize") {
            minBuild = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (maxBuild !== "" && (parseInt(minBuild.replace(/,/g, ''), 10) > parseInt(maxBuild.replace(/,/g, ''), 10))) {
                this.setState({ buildError: true })
            }
            else {
                this.setState({ buildError: false })
            }
        }
        else if (e.target.name === "MaxSize") {
            maxBuild = getFormattedInt(e.target.value.replace(/,/g, ''));
            if (minBuild !== "" && (parseInt(minBuild.replace(/,/g, ''), 10) > parseInt(maxBuild.replace(/,/g, ''), 10))) {

                this.setState({ buildError: true })
            }
            else {
                this.setState({ buildError: false })
            }
        }

        this.setState({ minBuild: minBuild, maxBuild: maxBuild });
    }


    onStateSelect = (event, selectedList, selectedItem) => {

        var stateIds = Array.prototype.map.call(selectedList, function (item) { return item.Id; }).join(",");
        var selectedStates = selectedList;
        this.setState({ selectedMSA: [], msaList: [], cityName: '', cityList: [], selectedStates, stateId: stateIds });

        if (stateIds !== "") {
            const data = {
                StateIDs: stateIds
            }

            axios.post(CONFIG.API_URL + 'lookup/msa', data).then(response => {
                if (response.status === 200) {

                    this.setState({ msaList: response.data });
                }
            })
                .catch(err => {
                    this.setState({ isLoading: false });
                });
        }
    }

    onMSASelect = (event, selectedList, selectedItem) => {
        this.setState({ selectedMSA: selectedList });
    }

    typeChange(e) {
        let propertyTypeId = e.target.value;
        this.setState({ propertyTypeId: propertyTypeId })
    }

    getPropertiesType() {
        axios.get(CONFIG.API_URL + 'lookup/propertytypes').then(response => {
            if (response.status === 200) {

                this.setState({ propertyTypeList: response.data });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    getHomeData() {
        axios.get(CONFIG.API_URL + 'industryinsights/' + CONFIG.REGION_ID)
            .then(res => {
                this.setState({ latestNewsAndEvents: res.data.latestPosts, leadStories: res.data.featuredPosts })
            })
            .catch((err) => {

            })
    }

    toggleClose() {
        this.clear();
        this.setState({ isAdvanedPopup: false });
    }

    searchKeyword() {

        const { userInput } = this.state;
        if (userInput === '') {
            this.setState({ noKeyWord: true });
        } else if (userInput.PropertyName === "") { this.setState({ noKeyWord: true }); }
        else {
            const data = {
                SearchKeyword: userInput ? userInput.PropertyName : '',
                PropertyTypeIds: this.state.propertyTypeIds,
                RegionId: CONFIG.REGION_ID
            }

            axios.post(CONFIG.API_URL + 'search/criteria', data)
                .then(response => {

                    if (response.status === 200) {
                        let searchId = response.data;
                        this.setState({ isAdvanedPopup: false, noKeyWord: false })
                        const { from } = { from: { pathname: "/listings/" + searchId } };
                        this.props.history.push(from);
                    }
                })
                .catch(err => {
                });
        }
    }

    openAdvancedSearch() {

        Geocode.setApiKey(CONFIG.GeolocationApiKey);
        Geocode.setLanguage("en");
        Geocode.enableDebug();
        if (CONFIG.REGION_ID !== REGIONS.UK) {
            this.getLookupState();
        }
        this.getMarketfeatures();
        this.getPriceRangeTypes();
        this.setState({ isAdvanedPopup: true })
    }

    roomExpansionOnChange(e) {

        let isRoomExpansion = !this.state.isRoomExpansion;
        this.setState({ isRoomExpansion: isRoomExpansion })
    }

    onChangeAddress(e) {
        if (e.target !== null) {
            if (e.target.name === "Zip") {
                this.setState({ defaultZip: e.target.value });
            }
            else if (e.target.name === "ProximitytoAddress") {
                this.setState({ proxAddress: e.target.value });
            }
            else if (e.target.name === "Proximity") {
                var val = parseInt(e.target.value, 10);
                this.setState({ defaultProximity: val });
            }
            else if (e.target.name === "Market$PSFaverage") {
                this.setState({ defaultPSF: e.target.value });
            }
            else if (e.target.name === "AvPopStore") {
                this.setState({ defaultPop: e.target.value });
            }
            else if (e.target.name === "CurrentSqFtCaptia") {
                this.setState({ defaultSqFt: e.target.value });
            }
            else if (e.target.name === "Showonlywithroomforexpansion") {
                this.setState({ defaultShow: e.target.checked });
            }
            else if (e.target.name === "ExpansionAndPortFolio") {
                this.setState({ defaultExpansion: true });
            }
            //  var address = values.Address1 + "," + values.City + "," + state[0].Name + ",USA";// + values.Country;
        }
    }

    onKeyFloatChange(e) {
        let name = e.target.name;
        let value = getFormattedFloat(e.target.value.replace(/,/g, ''));
        if (name === "AvPopStore") {
            this.setState({ defaultPop: value })
        }
        else if (name === "Market$PSFaverage") {
            this.setState({ defaultPSF: value })
        }

        else if (name === "CurrentSqFtCaptia") {
            this.setState({ defaultSqFt: value })
        }
    }

    handleCityChange(e) {

        var city = e.currentTarget.value;
        const obj = {
            Name: city,
            StateID: '',
        }

        this.setState({ cityName: obj });

        if (city.trim() === "") {
            this.setState({ cityList: [] });
        }
        else {
            const data = {
                Keyword: city,
                StateIDs: this.state.stateId,
                RegionID: CONFIG.REGION_ID
            }
            axios.post(CONFIG.API_URL + 'search/city', data).then(response => {

                if (response.status === 200) {

                    this.setState({ cityList: response.data, showCityList: true });
                }
            })
                .catch(err => {
                    this.setState({ isLoading: false });
                });
        }
    }

    getMarketfeatures() {

        axios.get(CONFIG.API_URL + 'lookup/marketfeatures/' + CONFIG.REGION_ID).then(response => {
            if (response.status === 200) {

                let MVPMarketPSFAverage = response.data[0].MVPMarketPSFAverage;
                let MVPAveragePopulationPerStore = response.data[0].MVPAveragePopulationPerStore;
                let MVPCurrentSQFTPerCapita = response.data[0].MVPCurrentSQFTPerCapita;
                this.setState({ MVPMarketPSFAverage: MVPMarketPSFAverage, MVPAveragePopulationPerStore: MVPAveragePopulationPerStore, MVPCurrentSQFTPerCapita: MVPCurrentSQFTPerCapita });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });

    }

    getLookupState() {

        axios.get(CONFIG.API_URL + 'lookup/state/' + CONFIG.US_CountryId).then(response => {
            if (response.status === 200) {
                this.setState({ stateList: response.data, backupList: response.data });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    getPriceRangeTypes() {
        axios.get(CONFIG.API_URL + 'lookup/pricerangetypes').then(response => {
            if (response.status === 200) {
                this.setState({ priceRangeTypesList: response.data });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    getMeasurementsTypes() {
        axios.get(CONFIG.API_URL + 'lookup/measurements').then(response => {
            if (response.status === 200) {
                this.setState({ measurementsList: response.data });
            }
        })
            .catch(err => {
                this.setState({ isLoading: false });
            });
    }

    clear() {
        this.setState({
            defaultTypeRangeID: 1,
            selectedValue: null, selectedStates: [], stateId: '', selectedMSA: [], msaList: [], cityList: [], cityName: '', minBuild: '', maxBuild: '', minPrice: '', maxPrice: '', minNRSF: '', maxNRSF: '', minLot: '', maxLot: '', defaultLotId: 1, proxAddress: '', defaultZip: '',
            defaultProximity: 5, defaultPSF: '', defaultPop: '', defaultSqFt: '', defaultShow: false, defaultExpansion: '', addressError: '', priceError: false, isMSAError: false
        })
    }

    advancedSearch(event, errors, values) {
        this.props.dispatch(showLoader());

        const { cityName, selectedMSA, stateId } = this.state;
        var city = cityName ? cityName.Name : '';
        var cityState = cityName ? cityName.StateID : '';
        var cityId = cityName ? cityName.ID : '';
        var msaId = Array.prototype.map.call(selectedMSA, function (item) { return item.ID; }).join(",");

        this.setState({ addressError: '' });

        if (this.state.priceError === false && this.state.nrsfError === false && this.state.lotError === false && this.state.buildError === false) {
            if (values.ProximitytoAddress !== "") {
                if (city !== "") {

                    var address = values.ProximitytoAddress + "," + city + "," + cityState + ",USA";// + values.Country;

                    Geocode.fromAddress(address).then(
                        response => {
                            const { lat, lng } = response.results[0].geometry.location;
                            this.setState({ lat: lat, lng: lng })
                            if (errors.length === 0) {

                                const data = {
                                    //  SearchID: parseInt(values.SearchID === "" ? 0 : values.SearchID, 10),
                                    SearchKeyword: '',
                                    StateIds: stateId,
                                    MSAListIds: msaId,
                                    Address: values.ProximitytoAddress,
                                    CityIds: cityId,
                                    Zipcode: values.Zip,
                                    Proximity: values.Proximity !== "" ? parseInt(values.Proximity, 10) : "5",
                                    Latitude: this.state.lat,
                                    Longitude: this.state.lng,
                                    MinPrice: values.MinPrice !== "" ? parseInt(values.MinPrice.replace(/,/g, ''), 10) : "",
                                    MaxPrice: values.MaxPrice !== "" ? parseInt(values.MaxPrice.replace(/,/g, ''), 10) : "",
                                    PriceRangeTypeId: values.PriceRange !== "" ? parseInt(values.PriceRange, 10) : "",
                                    MinLotSize: values.MinLotSize !== "" ? parseInt(values.MinLotSize.replace(/,/g, ''), 10) : "",
                                    MaxLotSize: values.MaxLotSize !== "" ? parseInt(values.MaxLotSize.replace(/,/g, ''), 10) : "",
                                    LotsizeMeasurementId: values.SizeRange !== "" ? parseInt(values.SizeRange, 10) : "",
                                    MinNRSF: values.MinNRSF !== "" ? parseInt(values.MinNRSF.replace(/,/g, ''), 10) : "",
                                    MaxNRSF: values.MaxNRSF !== "" ? parseInt(values.MaxNRSF.replace(/,/g, ''), 10) : "",
                                    ShowOnlyWithRoomOfExpansion: values.Showonlywithroomforexpansion,
                                    PortfoliosOnly: values.ExpansionAndPortFolio === "2" ? true : false,
                                    ExcludePortfolios: values.ExpansionAndPortFolio === "3" ? true : false,
                                    MarketPSFAverage: values.Market$PSFaverage !== "" ? parseFloat(values.Market$PSFaverage.replace(/,/g, '')) : '',
                                    AvPopulationPerStore: values.AvPopStore !== "" ? parseFloat(values.AvPopStore.replace(/,/g, '')) : '',
                                    CurrentSqftPerCapita: values.CurrentSqFtCaptia !== "" ? parseFloat(values.CurrentSqFtCaptia.replace(/,/g, '')) : '',
                                    RegionId: CONFIG.REGION_ID
                                }

                                axios.post(CONFIG.API_URL + 'search/criteria', data)
                                    .then(response => {

                                        if (response.status === 200) {
                                            let searchId = response.data;
                                            this.setState({ isAdvanedPopup: false })

                                            const { from } = { from: { pathname: "/listings/" + searchId } };
                                            this.props.history.push(from);

                                        }
                                    })
                                    .catch(err => {
                                        this.props.dispatch(hideLoader());
                                    });
                            }

                        },
                        error => {
                            this.props.dispatch(hideLoader());
                            this.setState({ addressError: 'Please enter valid address' });
                        }
                    );
                } else {
                    this.props.dispatch(hideLoader());
                    this.setState({ addressError: 'Please enter city' });
                }
            }
            else {
                if (errors.length === 0) {
                    const data = {
                        SearchKeyword: '',
                        StateIds: stateId,
                        MSAListIds: msaId,
                        Address: values.ProximitytoAddress,
                        CityIds: cityId,
                        Zipcode: values.Zip,
                        Proximity: values.Proximity !== "" ? parseInt(values.Proximity, 10) : "5",
                        Latitude: this.state.lat,
                        Longitude: this.state.lng,
                        MinPrice: values.MinPrice !== "" ? parseInt(values.MinPrice.replace(/,/g, ''), 10) : "",
                        MaxPrice: values.MaxPrice !== "" ? parseInt(values.MaxPrice.replace(/,/g, ''), 10) : "",
                        PriceRangeTypeId: values.PriceRange !== "" ? parseInt(values.PriceRange, 10) : "",
                        MinLotSize: values.MinLotSize !== "" ? parseInt(values.MinLotSize.replace(/,/g, ''), 10) : "",
                        MaxLotSize: values.MaxLotSize !== "" ? parseInt(values.MaxLotSize.replace(/,/g, ''), 10) : "",
                        LotsizeMeasurementId: values.SizeRange !== "" ? parseInt(values.SizeRange, 10) : "",
                        MinNRSF: values.MinNRSF !== "" ? parseInt(values.MinNRSF.replace(/,/g, ''), 10) : "",
                        MaxNRSF: values.MaxNRSF !== "" ? parseInt(values.MaxNRSF.replace(/,/g, ''), 10) : "",
                        ShowOnlyWithRoomOfExpansion: values.Showonlywithroomforexpansion,
                        PortfoliosOnly: values.ExpansionAndPortFolio === "2" ? true : false,
                        ExcludePortfolios: values.ExpansionAndPortFolio === "3" ? true : false,
                        MarketPSFAverage: values.Market$PSFaverage !== "" ? parseFloat(values.Market$PSFaverage.replace(/,/g, '')) : '',
                        AvPopulationPerStore: values.AvPopStore !== "" ? parseFloat(values.AvPopStore.replace(/,/g, '')) : '',
                        CurrentSqftPerCapita: values.CurrentSqFtCaptia !== "" ? parseFloat(values.CurrentSqFtCaptia.replace(/,/g, '')) : '',
                        RegionId: CONFIG.REGION_ID
                    }

                    axios.post(CONFIG.API_URL + 'search/criteria', data)
                        .then(response => {
                            if (response.status === 200) {
                                let searchId = response.data;
                                this.setState({ isAdvanedPopup: false })

                                const { from } = { from: { pathname: "/listings/" + searchId } };
                                this.props.history.push(from);
                            }
                        })
                        .catch(err => {
                            this.props.dispatch(hideLoader());
                        });
                }
            }
        }
        else
            this.props.dispatch(hideLoader());
    }

    propertyCheckBox = (checkData) => {

        let data = this.state.propertyTypeList;
        checkData.IsChecked = checkData.IsChecked === 0 ? 1 : 0;
        if (checkData.IsChecked === 1) {
            data.forEach(d => {
                if (d.Name === checkData.Name)
                    d.IsChecked = 1
            })
            this.setState({ propertyTypeList: data });
        } else if (checkData.IsChecked === 0) {
            data.forEach(d => {
                if (d.Name ===
                    checkData.Name)
                    d.IsChecked = 0
            })
            this.setState({ propertyTypeList: data });
        }

        let filterArr = [];
        let sendFinalData = this.state.propertyTypeList;
        let selectedTrueOnly = sendFinalData.filter(data => data.IsChecked === 1);
        if (selectedTrueOnly.length > 0) {
            if (selectedTrueOnly.length === 1) {
                this.setState({ displayValue: selectedTrueOnly[0].Name, imgId: 0 })

            }
            if (selectedTrueOnly.length === 2) {
                this.setState({ displayValue: selectedTrueOnly[0].Name, imgId: 1 })

            }
            else if (selectedTrueOnly.length === 3) {
                this.setState({ displayValue: selectedTrueOnly[0].Name, imgId: 2 })
            }
            else if (selectedTrueOnly.length === 4) {
                this.setState({ displayValue: selectedTrueOnly[0].Name, imgId: 3 })
            }
            else { this.setState({ displayValue: selectedTrueOnly[0].Name }) }
        }
        else {
            this.setState({ displayValue: 'Property Search', imgId: 0 })
        }
        selectedTrueOnly.forEach(d => {
            filterArr.push(d.ID)
        })

        let propertyTypeIds = filterArr.toString();
        this.setState({ propertyTypeIds })



    }

    setOpen = (open, params) => {
        this.setState({ open });
    }

    citySelect = (e, value) => {
        var cityName = value;
        this.setState({ cityName });
    }

    searchSelect = (event, property) => {
        if (property) {
            if (property.PropertyId) {
                const { from } = { from: { pathname: "/property/" + property.Permalink} };
                this.props.history.push(from);
            } else {
                this.searchKeyword();
            }
        }
    }

    setOpenSearch(openSearch) {
        this.setState({ openSearch });
    }

    setOpenMSA = (openMSA, params) => {
        const { selectedStates } = this.state;

        var isMSAError = false;
        if (selectedStates.length === 0) {
            isMSAError = true;
        }
        this.setState({ openMSA, isMSAError });
    }

    autoCompleteClearEventListener() {
        // Take the Reference of Close Button
        const close = document.getElementsByClassName(
            "MuiAutocomplete-clearIndicator"
        )[0];

        // Add a Click Event Listener to the button
        close.addEventListener("click", () => {
            // alert("Add your Own Functionality Here...");
            this.setState({ userInput: '',propertyNameList:[]  });
        });
    }

    render() {
        const { listingCount, latestNewsAndEvents, leadStories, selectedStates, selectedMSA, userInput, propertyNameList, isAdvanedPopup, stateList, msaList, priceRangeTypesList, measurementsList, cityName, cityList, MVPMarketPSFAverage, MVPAveragePopulationPerStore, MVPCurrentSQFTPerCapita, addressError, featuredListings, noKeyWord,
            minPrice, priceError, maxPrice, minLot, maxLot, lotError, minNRSF, maxNRSF, nrsfError, defaultLotId, defaultTypeRangeID, proxAddress, defaultZip, defaultProximity, defaultPSF, defaultPop, defaultSqFt, defaultShow, defaultExpansion, featuredVendorListings, open, openSearch, openMSA, isMSAError } = this.state;
        // document.title = CONFIG.PAGE_TITLE + 'Home';
        return (
            <div className="homepage">
                <Helmet
                    title='Home'
                    addPostfixTitle={true}
                    keywords="Home, Search, Featured Listings, Industry Insights, Featured Vendors"
                />
                <div className={CONFIG.REGION_ID === REGIONS.UK ? "banner-homepage uk-banner-homepage" : "banner-homepage"}>
                    <h2>Search self storage properties for sale</h2>
                    <AvForm onSubmit={this.searchKeyword.bind(this)} id="LSS_home_search_form">
                        <div className="box-search-home">
                            <React.Fragment>
                                <div className={noKeyWord === true ? "inputbox-search-empty" : "inputbox-search"}>
                                    <Autocomplete
                                        id="asynchronous-demo1"
                                        name="city"
                                        open={openSearch}
                                        onOpen={() => {
                                            this.setOpenSearch(true);
                                        }}
                                        onClose={() => {
                                            this.setOpenSearch(false);
                                        }}
                                        onChange={this.searchSelect}
                                        value={userInput ? userInput : ''}
                                        getOptionLabel={(option) => option ? option.PropertyName : ''}
                                        options={propertyNameList}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={"Search our " + listingCount + " properties"}
                                                onChange={this.handleKeyChange}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </React.Fragment>
                            <Button className="button-search-home"><FontAwesomeIcon icon={faSearch} /> Search</Button>
                            <Link role="button" className="advanced-search-home advanced-search-text" onClick={this.openAdvancedSearch.bind(this)}>Advanced Search</Link>
                        </div>
                    </AvForm>


                    <div className="clear"></div>
                </div>
                <div className="clear"></div>
                <div className="home-content">
                    <Container>
                        {featuredListings ?
                            <React.Fragment>
                                <Col sm={12} className="page-header padding-t40">
                                    <h2 className="page-title margin-b-15">Today's featured listings</h2>
                                    <Row className="padding-t-0">
                                        <Col sm={4}></Col>
                                        <Col sm={4}>
                                            <div className="title-separator1"></div>
                                        </Col>
                                        <Col sm={4}></Col>
                                    </Row>
                                    <div>
                                        <a className="blue-large-button" role="button" href="/listings">View All Listings</a>
                                    </div>
                                </Col>
                                <Row className="margin-b-20">
                                    {featuredListings.length > 0 ? featuredListings.map(property =>
                                        <Col sm={4} className="margin-t25 margin-b25 col-custom-padding">
                                            <ListingTile key={property.PropertyId} property={property} isHome={true} />
                                        </Col>
                                    ) : <Col md={12} className="text-align-center no-records-found">No Featured Listings Found</Col>}
                                </Row>
                            </React.Fragment>
                            : ''}
                        <Row className="eventscontent">

                            <Col sm={12} className="margin-b25">
                                <h2 className="page-title margin-b-10 title-hover"><a href="/industry-insights/" rel="noreferrer">INDUSTRY INSIGHTS</a>
                                    {/* <Link to="/industry-insights/" className="float-right go-to-btn"><FontAwesomeIcon icon={faNewspaper} /> Go to Main News Page</Link> */}
                                </h2>
                                <Row className="padding-t-0">
                                    <Col sm={4}></Col>
                                    <Col sm={4}>
                                        <div className="title-separator1"></div>
                                    </Col>
                                    <Col sm={4}></Col>
                                </Row>
                            </Col>
                            <Col sm={8} >
                                <div className="lead-story">
                                    <div className="overlay-story">
                                        {leadStories.length > 0 ?
                                            <Carousel showArrows={true} showThumbs={false} 
                                                autoPlay={true} infiniteLoop={true} interval={3000} transitionTime={60}>
                                                {leadStories.map((data) =>
                                                    <div className="slider-img">
                                                        <img src={'/industry-insights/wp-content/uploads/' + data.image} onError={(e) => { e.target.onerror = null; e.target.src = leadstory }} className="width-100 height-100" alt="Image"/>
                                                        <a href={data.guid} rel="noreferrer">
                                                            <div className="legend">
                                                                {data.categories ?
                                                                    <div className="display-fullflex">
                                                                        {data.categories.includes('Best') ? <div className="category-name best-practices">Best Practices</div> : ''}
                                                                        {data.categories.includes('Finance') ? <div className="category-name fin-news">Finance News</div> : ''}
                                                                        {data.categories.includes('Anatomy') ? <div className="category-name anatomy-news">Anatomy of a Deal</div> : ''}
                                                                        {data.categories.includes('Coffee') ? <div className="category-name coffee-news">Coffee & Conversation</div> : ''}
                                                                        {data.categories.includes('Broker') ? <div className="category-name featured-news">Featured Broker</div> : ''}
                                                                        {data.categories.includes('Five') ? <div className="category-name five-news">Five Minutes with…</div> : ''}
                                                                        {data.categories.includes('Month') ? <div className="category-name market-news">Market of the Month</div> : ''}
                                                                        {data.categories.includes('Transactions') ? <div className="category-name recent-news">Recent Transactions</div> : ''}
                                                                        {data.categories.includes('Resources') ? <div className="category-name resources-news">Resources</div> : ''}
                                                                        {data.categories.includes('Sponsored') ? <div className="category-name spon-news">Sponsored</div> : ''}
                                                                        {data.categories.includes('Talks') ? <div className="category-name tech-news">Tech Talks</div> : ''}
                                                                        {data.categories.includes('Development') ? <div className="category-name five-news">Development News</div> : ''}
                                                                    </div>
                                                                    : ''}

                                                                <h4>{data.post_title.length > 80 ? data.post_title.substring(0, 80) + '...' : data.post_title}</h4>

                                                                <p className="para-height51" >{stripHtmlTags(data.post_content, false, 260)}</p>
                                                                <p className="margin-with-content">
                                                                    <span className="lead-caleder"><FontAwesomeIcon icon={faCalendarAlt} />{moment(data.post_date).format("MMMM DD, YYYY")}</span>
                                                                </p>
                                                            </div>
                                                        </a>
                                                    </div>
                                                )}
                                            </Carousel>
                                            :
                                            <div className="slider-img">
                                                <img src={leadstory} className="width-100 height-100" alt="Image"/>
                                            </div>}
                                    </div>
                                </div>
                                <div className="slider-below">
                                    <Row>
                                        {
                                            latestNewsAndEvents && latestNewsAndEvents.length > 3 ? latestNewsAndEvents.slice(3, 5).map((prac) =>
                                                <React.Fragment>
                                                    <Col md={6}>
                                                        <a href={prac.guid} rel="noreferrer">
                                                            <div className="news-box">
                                                                {prac.categories ?
                                                                    <div className="display-fullflex">
                                                                        {prac.categories.includes('Best') ? <div className="category-name best-practices">Best Practices</div> : ''}
                                                                        {prac.categories.includes('Finance') ? <div className="category-name fin-news">Finance News</div> : ''}
                                                                        {prac.categories.includes('Anatomy') ? <div className="category-name anatomy-news">Anatomy of a Deal</div> : ''}
                                                                        {prac.categories.includes('Coffee') ? <div className="category-name coffee-news">Coffee & Conversation</div> : ''}
                                                                        {prac.categories.includes('Broker') ? <div className="category-name featured-news">Featured Broker</div> : ''}
                                                                        {prac.categories.includes('Five') ? <div className="category-name five-news">Five Minutes with…</div> : ''}
                                                                        {prac.categories.includes('Month') ? <div className="category-name market-news">Market of the Month</div> : ''}
                                                                        {prac.categories.includes('Transactions') ? <div className="category-name recent-news">Recent Transactions</div> : ''}
                                                                        {prac.categories.includes('Resources') ? <div className="category-name resources-news">Resources</div> : ''}
                                                                        {prac.categories.includes('Sponsored') ? <div className="category-name spon-news">Sponsored</div> : ''}
                                                                        {prac.categories.includes('Talks') ? <div className="category-name tech-news">Tech Talks</div> : ''}
                                                                    </div>
                                                                    : ''}
                                                                <h4 title={prac.post_title}>{prac.post_title}</h4>
                                                                <div className="news-para-height"><p>{substringStripHtmlTag(prac.post_content, 158)}</p></div>

                                                                <Row className="month-date">
                                                                    <Col sm={6}><span className="month"><FontAwesomeIcon icon={faCalendarAlt} />{moment(prac.post_date).format("MMMM DD, YYYY")}</span></Col>
                                                                </Row>
                                                            </div>
                                                        </a>
                                                    </Col>
                                                </React.Fragment>
                                            ) : ''
                                        }
                                    </Row>
                                </div>
                            </Col>
                            <Col sm={4} className="">
                                {
                                    latestNewsAndEvents && latestNewsAndEvents.length > 0 ? latestNewsAndEvents.slice(0, 3).map((prac) =>
                                        <React.Fragment>
                                            <a href={prac.guid}>
                                                <div className="news-box">
                                                    {prac.categories ?
                                                        <div className="display-fullflex">
                                                            {prac.categories.includes('Best') ? <div className="category-name best-practices">Best Practices</div> : ''}
                                                            {prac.categories.includes('Finance') ? <div className="category-name fin-news">Finance News</div> : ''}
                                                            {prac.categories.includes('Anatomy') ? <div className="category-name anatomy-news">Anatomy of a Deal</div> : ''}
                                                            {prac.categories.includes('Coffee') ? <div className="category-name coffee-news">Coffee & Conversation</div> : ''}
                                                            {prac.categories.includes('Broker') ? <div className="category-name featured-news">Featured Broker</div> : ''}
                                                            {prac.categories.includes('Five') ? <div className="category-name five-news">Five Minutes with…</div> : ''}
                                                            {prac.categories.includes('Month') ? <div className="category-name market-news">Market of the Month</div> : ''}
                                                            {prac.categories.includes('Transactions') ? <div className="category-name recent-news">Recent Transactions</div> : ''}
                                                            {prac.categories.includes('Resources') ? <div className="category-name resources-news">Resources</div> : ''}
                                                            {prac.categories.includes('Sponsored') ? <div className="category-name spon-news">Sponsored</div> : ''}
                                                            {prac.categories.includes('Talks') ? <div className="category-name tech-news">Tech Talks</div> : ''}
                                                            {prac.categories.includes('Development') ? <div className="category-name five-news">Development News</div> : ''}
                                                        </div>
                                                        : ''}
                                                    <h4 title={prac.post_title}>{prac.post_title}</h4>
                                                    {/* <div dangerouslySetInnerHTML={{ __html: prac.ArticleDescription }}></div> */}
                                                    <div className="news-para-height"><p>{substringStripHtmlTag(prac.post_content, 158)}</p></div>
                                                    <Row className="month-date">
                                                        {/* <Col sm={6}><span className="date">{prac.MinutesRead} min read</span></Col> */}
                                                        <Col sm={6}><span className="month"><FontAwesomeIcon icon={faCalendarAlt} />{moment(prac.post_date).format("MMMM DD, YYYY")}</span></Col>
                                                    </Row>
                                                </div>
                                            </a>
                                        </React.Fragment>
                                    ) : ''
                                }
                            </Col>
                            {featuredVendorListings ?
                                <React.Fragment>
                                    <Col sm={12} className="margin-t25 margin-b25">
                                        <h2 className="page-title margin-b-10 title-hover"><Link to="/vendors">Featured Vendors</Link></h2>
                                        <Row className="padding-t-0">
                                            <Col sm={4}></Col>
                                            <Col sm={4}>
                                                <div className="title-separator1"></div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Row className="width-100 marginall-auto">
                                        {featuredVendorListings.length > 0 ? featuredVendorListings.map(vendor =>
                                            <Col sm={3}>
                                                
                                                    <div className="home-fv">
                                                        <div className="fv-home-size">
                                                            <img src={'/VendorLogos/' + vendor.Logo} onError={(e) => { e.target.onerror = null; e.target.src = vendor_no }} className="width-100  height-100" alt="Vendor"/>
                                                        </div>
                                                        <div className="home-content-box">
                                                            <h6>{vendor.CompanyName}</h6>
                                                            <p className="para-margin-b" >{substringStripHtmlTag(vendor.Description, 240)}  <Link to={"/vendors/profile/" + vendor.Permalink}>Read More</Link></p>                                                          
                                                        </div>
                                                    </div>
                                            </Col>
                                        ) : <Col md={12} className="text-align-center no-records-found">No Featured Vendors Found</Col>}
                                    </Row>
                                </React.Fragment>
                                : ''}
                        </Row>
                    </Container>
                </div><div>
                    <Modal size="md" isOpen={isAdvanedPopup} toggle={this.toggleClose.bind(this)} className="pop-up-model-home">
                        <ModalHeader toggle={this.toggleClose.bind(this)}>
                            Advanced Search
                        </ModalHeader>
                        <ModalBody>
                            <AvForm onSubmit={this.advancedSearch.bind(this)} ref={c => (this.myFormRef = c)} id="LSS_home_advanced_search_form">
                                <Row>
                                    <Col sm={4}>
                                        <div >
                                            <h4 className="heading-margin-extra">Location</h4>
                                            {CONFIG.REGION_ID !== REGIONS.UK ?
                                                <React.Fragment>
                                                    <div className="disply-flex width-100 city-selection statescroll">
                                                        <Label>State:</Label>
                                                        <div className="width-100">
                                                            <Autocomplete
                                                                multiple
                                                                id="tags-standard"
                                                                options={stateList}
                                                                value={selectedStates}
                                                                getOptionLabel={(option) => option ? option.Id : ''}
                                                                onChange={this.onStateSelect}
                                                                renderInput={(params) => (
                                                                    <div className="text-state">
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                        />
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="disply-flex width-100 city-selection statescroll" onKeyPress={selectedStates && selectedStates.length > 0 ? '' : () => this.onKeyChangemultiMSA()}>
                                                        <Label>MSA:</Label>
                                                        <div className="width-100">
                                                            <Autocomplete
                                                                multiple
                                                                id="tags-standard"
                                                                open={openMSA}
                                                                onOpen={() => {
                                                                    this.setOpenMSA(true);
                                                                }}
                                                                onClose={() => {
                                                                    this.setOpenMSA(false);
                                                                }}
                                                                options={msaList}
                                                                value={selectedMSA}
                                                                getOptionLabel={(option) => option ? option.Name : ''}
                                                                onChange={this.onMSASelect}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        error={isMSAError}
                                                                        helperText={isMSAError ? "Please select state" : ''}
                                                                        {...params}
                                                                        variant="outlined"
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                                : ''}
                                            {CONFIG.REGION_ID === REGIONS.US ?
                                                <div className="disply-flex width-100 city-selection last-field">
                                                    <Label className="city-lable">City:&nbsp;&nbsp;</Label>
                                                    <div className="width-100">
                                                        <Autocomplete
                                                            id="asynchronous-demo"
                                                            name="city"
                                                            open={open}
                                                            onOpen={() => {
                                                                this.setOpen(true);
                                                            }}
                                                            onClose={() => {
                                                                this.setOpen(false);
                                                            }}
                                                            onChange={this.citySelect}
                                                            value={cityName ? cityName : ''}
                                                            getOptionLabel={(option) => option ? option.StateID ? option.Name + ", " + option.StateID : option.Name : ''}
                                                            options={cityList}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    onChange={this.handleCityChange}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <React.Fragment>
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                : CONFIG.REGION_ID === REGIONS.UK ?
                                                    <div className="city-selection2 town-city">
                                                        <Label >Town/City:</Label>
                                                        <div className="width-100">
                                                            <Autocomplete
                                                                id="asynchronous-demo"
                                                                name="city"
                                                                open={open}
                                                                onOpen={() => {
                                                                    this.setOpen(true);
                                                                }}
                                                                onClose={() => {
                                                                    this.setOpen(false);
                                                                }}
                                                                onChange={this.citySelect}
                                                                value={cityName ? cityName : ''}
                                                                getOptionLabel={(option) => option ? option.StateID ? option.Name + ", " + option.StateID : option.Name : ''}
                                                                options={cityList}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        onChange={this.handleCityChange}
                                                                        InputProps={{
                                                                            ...params.InputProps,
                                                                            endAdornment: (
                                                                                <React.Fragment>
                                                                                    {params.InputProps.endAdornment}
                                                                                </React.Fragment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                    : ""}

                                            {addressError ? <span className="error-ad-search1 error-ad-search5">{addressError}</span> : ''}
                                            <AvField name="ProximitytoAddress" maxLength="255" type="text" value={proxAddress} label="Street Address" onChange={this.onChangeAddress} autoComplete="chrome-off"/>
                                            <AvField name="Zip" maxLength="255" type="text" value={defaultZip} label={CONFIG.REGION_ID === REGIONS.UK ? "Postcode" : "Zip Code"} onChange={this.onChangeAddress} autoComplete="chrome-off" />
                                            <div className="within-field">
                                                <AvField type="select" name="Proximity" label="Within" value={defaultProximity} onChange={this.onChangeAddress}>
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </AvField>
                                                <span>miles of this address</span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div>
                                            <h4>Price & Property Features</h4>
                                            <h6 className="heading-margin-reduce">Price</h6>
                                            <Row>
                                                {priceError === true ? <span className="error-ad-search1">The maximum price can't be less than the minimum price</span> : ''}
                                                <div className="padding-search width-47">
                                                    <div className="max-min-price">
                                                        <AvField name="MinPrice" maxLength="13" value={minPrice} placeholder="Min Price" onChange={(e) => this.onKeyPriceNumberChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    </div>
                                                </div>
                                                <div className="width-6">
                                                    <span>To</span>
                                                </div>
                                                <div className="padding-search2 width-47">
                                                    <div className="max-min-price">
                                                        <AvField name="MaxPrice" maxLength="13" value={maxPrice} placeholder="Max Price" onChange={(e) => this.onKeyPriceNumberChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    </div>
                                                </div>
                                            </Row>
                                            <AvRadioGroup inline name="PriceRange" label="" className="radius-btn-search" value={defaultTypeRangeID} onChange={(e) => this.onPriceTypeChange(e)}>

                                                {priceRangeTypesList ? priceRangeTypesList.map(n => {
                                                    return (
                                                        <AvRadio label={n.Name} value={n.ID} />
                                                    );
                                                }) : ''}
                                            </AvRadioGroup>
                                            <h6>Lot Size</h6>
                                            <Row>
                                                {lotError === true ? <span className="error-ad-search1 error-ad-search3">The maximum size can't be less than the minimum size.</span> : ''}
                                                <div className="padding-search width-47">
                                                    <div className="max-min-price2">
                                                        <AvField name="MinLotSize" maxLength="13" value={minLot} placeholder="Min Size" onChange={(e) => this.onKeyLotNumberChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    </div>
                                                </div>
                                                <div className="width-6">
                                                    <span>To</span>
                                                </div>
                                                <div className="padding-search2 width-47">
                                                    <div className="max-min-price2">
                                                        <AvField name="MaxLotSize" maxLength="13" value={maxLot} placeholder="Max Size" onChange={(e) => this.onKeyLotNumberChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    </div>
                                                </div>
                                            </Row>
                                            <AvRadioGroup inline name="SizeRange" maxLength="13" label="" className="radius-btn-search" value={defaultLotId} onChange={(e) => this.onLotTypeChange(e)}>

                                                {measurementsList ? measurementsList.map(n => {
                                                    return (
                                                        <AvRadio label={n.Name} value={n.ID} />
                                                    );
                                                }) : ''}
                                            </AvRadioGroup>

                                            <h6>NRSF</h6>
                                            <Row>
                                                {nrsfError === true ? <span className="error-ad-search1 error-ad-search4">The maximum size can't be less than the minimum size.</span> : ''}
                                                <div className="padding-search width-47">
                                                    <div className="max-min-price2">
                                                        <AvField name="MinNRSF" maxLength="13" value={minNRSF} placeholder="Min" onChange={(e) => this.onKeyNRSFNumberChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    </div>
                                                </div>
                                                <div className="width-6">
                                                    <span>To</span>
                                                </div>
                                                <div className="padding-search2 width-47">
                                                    <div className="max-min-price2">
                                                        <AvField name="MaxNRSF" maxLength="13" value={maxNRSF} placeholder="Max" onChange={(e) => this.onKeyNRSFNumberChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    </div>
                                                </div>
                                            </Row>
                                            <div className="margin-t7 show-room-only">
                                                <AvField type="radio" name="Showonlywithroomforexpansion" value={defaultShow} label="Show only with room for expansion" onChange={this.onChangeAddress} checked={defaultShow ? true : false} />
                                            </div>

                                            <AvRadioGroup inline name="ExpansionAndPortFolio" label="" value={defaultExpansion} onChange={this.onChangeAddress}>
                                                <AvRadio label="Portfolios Only" value="2" />
                                                <AvRadio label="Exclude Portfolios" value="3" />
                                            </AvRadioGroup>
                                        </div>
                                    </Col>
                                    <Col sm={4} className="no-right-margin ">
                                        <div>
                                            <h4 className="heading-margin-extra">Market Features <span>{CONFIG.REGION_ID !== REGIONS.UK ? "(three-mile radius)" : "(10-mile radius)"}</span></h4>
                                            <div className="market-radius">
                                                <h3>Average Cost Per Sq. Ft.</h3>
                                                <div className="market-radius-flex">
                                                    <AvField name="Market$PSFaverage" maxLength="13" type="text" value={defaultPSF} label="more than" onChange={(e) => this.onKeyFloatChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    <div className="App">
                                                        <FontAwesomeIcon icon={faInfoCircle} data-tip data-for="registerTip2" />
                                                        <ReactTooltip id="registerTip2" place="top" effect="solid">
                                                            {CONFIG.REGION_ID !== REGIONS.UK ? "National Average is " + CURRENCY.US + MVPMarketPSFAverage + " psf" : "National Average is " + CURRENCY.UK + MVPMarketPSFAverage + " psf"}
                                                        </ReactTooltip>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="market-radius">
                                                <h3>Average Population Per Store</h3>
                                                <div className="market-radius-flex">
                                                    <AvField name="AvPopStore" maxLength="13" type="text" value={defaultPop} label="more than" onChange={(e) => this.onKeyFloatChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    <div className="App">
                                                        <FontAwesomeIcon icon={faInfoCircle} data-tip data-for="registerTip1" />
                                                        <ReactTooltip id="registerTip1" place="top" effect="solid">
                                                            {"National Average is  " + MVPAveragePopulationPerStore}
                                                        </ReactTooltip>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="market-radius">
                                                <h3>Sq. Ft. Per Capita</h3>
                                                <div className="market-radius-flex">
                                                    <AvField name="CurrentSqFtCaptia" maxLength="13" type="text" value={defaultSqFt} label="less than" onChange={(e) => this.onKeyFloatChange(e)} onKeyPress={(e) => this.onKeyPress(e)} />
                                                    <div className="App">
                                                        <FontAwesomeIcon icon={faInfoCircle} data-tip data-for="registerTip" />
                                                        <ReactTooltip id="registerTip" place="top" effect="solid">
                                                            {"National Average is " + MVPCurrentSQFTPerCapita + " SF/capita"}
                                                        </ReactTooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Col sm={12} className="text-align-right margin-t-15">
                                    <Button id="btn" className="save-btn"><FontAwesomeIcon icon={faSearch} /> Search</Button>
                                    <Button className="reset-btn padding-clear-home no-left-margin" onClick={this.clear.bind(this)}>Clear</Button>
                                </Col>
                            </AvForm>

                        </ModalBody>
                    </Modal>

                </div>

            </div>
        );
    }
}

export default connect()(Home);
